// import { createActionType, createAction } from '../shared/helpers/redux';

const toastPrefix = 'toast';

// TODO wywalić lokalne createAction i createActionType
export const createAction = (actionType) => (actionParams) => {
    return {
        type: actionType,
        ...actionParams
    };
};

const normlizeTypePart = (source) => source.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();

export const createActionType = (actionName) => (...prefixes) => {
    const actionNameNormalized = normlizeTypePart(actionName);
    const actionType = `${prefixes.map((prefix) => normlizeTypePart(prefix)).join('__')}__${actionNameNormalized}`;
    return actionType;
};

export const ActionTypes = {
    success: createActionType('success')(toastPrefix),
    warning: createActionType('warning')(toastPrefix),
    info: createActionType('info')(toastPrefix),
    error: createActionType('error')(toastPrefix),
    remove: createActionType('remove')(toastPrefix),
    addSuccess: createActionType('addSuccess')(toastPrefix),
    addWarning: createActionType('addWarning')(toastPrefix),
    addInfo: createActionType('addInfo')(toastPrefix),
    addError: createActionType('addError')(toastPrefix),
    removeInfo: createActionType('removeInfo')(toastPrefix),
};

export const success = createAction(ActionTypes.success);
export const warning = createAction(ActionTypes.warning);
export const info = createAction(ActionTypes.info);
export const error = createAction(ActionTypes.error);
export const remove = (toast) => createAction(ActionTypes.remove)({ payload: toast });
export const addSuccess = (message, dismiss = 0, id) => createAction(ActionTypes.addSuccess)({ payload: {
    message, dismiss, id
} });
export const addWarning = (message, dismiss = 0, id) => createAction(ActionTypes.addWarning)({ payload: {
    message, dismiss, id
} });
export const addInfo = (message, dismiss = 0, id) => createAction(ActionTypes.addInfo)({ payload: {
    message, dismiss, id
} });
export const addError = (message, dismiss = 0, id) => createAction(ActionTypes.addError)({ payload: {
    message, dismiss, id
} });

export const removeInfo = (id) => createAction(ActionTypes.removeInfo)({ payload: { id } });